// The screen table lays columns out automatically: each takes its content's width.
const agentColumns = (agentKey) => [{
    name: 'Agent 1',
    key: `${agentKey}1`,
}, {
    name: '%',
    key: `${agentKey}1Percent`,
    class: 'Fees_column_numeric',
    format: '%',
}, {
    name: '$',
    key: `${agentKey}1Price`,
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Agent 2',
    key: `${agentKey}2`,
}, {
    name: '%',
    key: `${agentKey}2Percent`,
    class: 'Fees_column_numeric',
    format: '%',
}, {
    name: '$',
    key: `${agentKey}2Price`,
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Agent 3',
    key: `${agentKey}3`,
}, {
    name: '%',
    key: `${agentKey}3Percent`,
    class: 'Fees_column_numeric',
    format: '%',
}, {
    name: '$',
    key: `${agentKey}3Price`,
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Outside Agent',
    key: `${agentKey}4`,
}, {
    name: '%',
    key: `${agentKey}4Percent`,
    class: 'Fees_column_numeric',
    format: '%',
}, {
    name: '$',
    key: `${agentKey}4Price`,
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}];

export const columns = [{
    name: 'Prop #',
    key: 'no',
}, {
    name: 'Close of Escrow',
    key: 'closeOfEscrow',
}, {
    name: 'Property Name',
    key: 'name',
}, {
    name: 'City',
    key: 'city',
}, {
    name: 'State',
    key: 'state',
}, {
    name: 'Total Fee',
    key: 'totalFee',
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Listing Agent',
    subColumns: agentColumns('listingAgent'),
}, {
    name: 'Buying Agent',
    subColumns: agentColumns('buyerAgent'),
}, {
    name: 'Type',
    key: 'transactionType',
}, {
    name: 'SUMMIT Fee',
    subName:"(Gross Fee)",
    key: 'striveFee',
    class: 'Fees_column_numeric',
    format: '$',
    withCents: true,
},];

const splitColumnIndex = 7;
const cloneDeep = require("lodash.clonedeep");

export const printFirstColumns = cloneDeep(columns.slice(0, splitColumnIndex));
//printFirstColumns.push(columns[9]);
printFirstColumns[0].name = '#';


export const printSecondColumns = columns.slice(splitColumnIndex);
// keep the first 4 columns on the second page as well
printSecondColumns.unshift({...columns[0]}, columns[1], columns[2], columns[3]);
printSecondColumns[0].name = '#';
